// Spanish for the SOS Field app: photos. Keys are the English text exactly as written in the code.
export default {
  // Departments (composables/useField.ts, DepartmentPicker)
  Mitigation: 'Mitigación',
  Recon: 'Reconstrucción',
  Packout: 'Empaque',
  Department: 'Departamento',
  'Water, fire and mold damage': 'Daños por agua, fuego y moho',
  'Rebuild and repairs': 'Reconstruir y reparar',
  'Contents and moving': 'Pertenencias y mudanza',

  // Home: camera first (PhotoHome, pages/field/photos.vue)
  'Take photos': 'Tomar fotos',
  'Take photo': 'Tomar foto',
  'Add from gallery': 'Agregar de la galería',
  'Take the photos first. You’ll pick the job next.':
    'Primero toma las fotos. Después eliges el trabajo.',
  '1 photo is waiting for a job.': 'Hay 1 foto esperando un trabajo.',
  '{count} photos are waiting for a job.':
    'Hay {count} fotos esperando un trabajo.',
  'Tap to choose the job.': 'Toca para elegir el trabajo.',
  Jobs: 'Trabajos',
  'Or open a job first': 'O abre un trabajo primero',
  'New job here': 'Trabajo nuevo aquí',
  'Job not in the CRM yet? Open one here. The office links it to the CRM project later.':
    '¿El trabajo no está en el CRM? Ábrelo aquí. La oficina lo conecta con el proyecto del CRM después.',
  'Could not save the photo': 'No se pudo guardar la foto',

  // Job list (JobPicker)
  'Search name, address or job number':
    'Buscar nombre, dirección o número de trabajo',
  'Search name, address or job #': 'Buscar nombre, dirección o # de trabajo',
  'No signal. Showing the job list saved on this phone.':
    'Sin señal. Se muestra la lista de trabajos guardada en este teléfono.',
  'Loading jobs': 'Cargando trabajos',
  'CRM project': 'Proyecto del CRM',
  'Field job': 'Trabajo de campo',
  'No address': 'Sin dirección',
  'No matching jobs': 'No hay trabajos que coincidan',
  'No open jobs': 'No hay trabajos abiertos',
  'Try another name, address or job number.':
    'Prueba otro nombre, dirección o número de trabajo.',
  'Open a new job below.': 'Abre un trabajo nuevo abajo.',
  'Show more ({count})': 'Ver más ({count})',

  // New job sheet and map (NewJobSheet, LocationPicker)
  'Waiting for your location. Try again in a moment.':
    'Esperando tu ubicación. Intenta de nuevo en un momento.',
  'No location yet': 'Todavía no hay ubicación',
  'Could not open the job': 'No se pudo abrir el trabajo',
  'Job location': 'Ubicación del trabajo',
  'Back to me': 'Volver a mi ubicación',
  'Drag the pin, or tap the map, onto the right house.':
    'Arrastra el pin, o toca el mapa, hasta la casa correcta.',
  'Pin is {distance} from you.': 'El pin está a {distance} de ti.',
  Address: 'Dirección',
  'Finding the address…': 'Buscando la dirección…',
  'Street, city': 'Calle, ciudad',
  'Job note': 'Nota del trabajo',
  '(optional)': '(opcional)',
  'Customer name, what happened…': 'Nombre del cliente, qué pasó…',
  'Open job': 'Abrir trabajo',
  'Loading map…': 'Cargando mapa…',
  'The map couldn’t load. We’ll use your GPS location. Check the address below.':
    'El mapa no cargó. Vamos a usar tu ubicación GPS. Revisa la dirección abajo.',

  // Which job? (pages/field/assign.vue)
  'Which job?': '¿Qué trabajo?',
  'Delete 1 photo from this phone? It was not uploaded.':
    '¿Borrar 1 foto de este teléfono? No se subió.',
  'Delete {count} photos from this phone? They were not uploaded.':
    '¿Borrar {count} fotos de este teléfono? No se subieron.',
  Back: 'Atrás',
  'All photos have a job': 'Todas las fotos tienen trabajo',
  'Take more photos': 'Tomar más fotos',
  'Which job are these for?': '¿De qué trabajo son?',
  '1 photo saved on this phone. It uploads as soon as you pick the job.':
    '1 foto guardada en este teléfono. Se sube en cuanto elijas el trabajo.',
  '{count} photos saved on this phone. They upload as soon as you pick the job.':
    '{count} fotos guardadas en este teléfono. Se suben en cuanto elijas el trabajo.',
  'Photos waiting for a job': 'Fotos esperando un trabajo',
  'Photo waiting for a job': 'Foto esperando un trabajo',
  'You’re here': 'Estás aquí',
  'Yes, add to this job': 'Sí, agregar a este trabajo',
  'No job here': 'No hay trabajo aquí',
  'Is this a new job?': '¿Es un trabajo nuevo?',
  'The nearest job is {distance} away.':
    'El trabajo más cercano está a {distance}.',
  'Open a new job here and the office links it to the CRM later.':
    'Abre un trabajo nuevo aquí y la oficina lo conecta con el CRM después.',
  'Yes, it’s a new job': 'Sí, es un trabajo nuevo',
  'Another job': 'Otro trabajo',
  'Or pick a job anyway': 'O elige un trabajo de todos modos',
  'Pick the job': 'Elige el trabajo',
  'It’s a new job': 'Es un trabajo nuevo',
  'Not in the CRM yet (e.g. a night call)? Open it here. The office links it to the CRM project later.':
    '¿Todavía no está en el CRM (por ejemplo, una llamada de noche)? Ábrelo aquí. La oficina lo conecta con el proyecto del CRM después.',
  'Delete these photos': 'Borrar estas fotos',
  'This job is far from you': 'Este trabajo está lejos de ti',
  'is {distance} from where you are.': 'está a {distance} de donde estás.',
  'Open a new job here': 'Abrir un trabajo nuevo aquí',
  'Add to {title} anyway': 'Agregar a {title} de todos modos',
  Cancel: 'Cancelar',

  // One job (pages/field/[kind]/[id].vue)
  Job: 'Trabajo',
  'Could not switch department': 'No se pudo cambiar de departamento',
  'Not added. To pick the right job, take the photo from the home screen.':
    'No se agregó. Para elegir el trabajo correcto, toma la foto desde la pantalla de inicio.',
  'Photo not added': 'La foto no se agregó',
  'Main photo': 'Foto principal',
  'This is now the job’s main photo.':
    'Ahora es la foto principal del trabajo.',
  'Main photo set': 'Foto principal lista',
  'Could not set the main photo': 'No se pudo poner la foto principal',
  'Photos go to the {department} folder.':
    'Las fotos van a la carpeta {department}.',
  'All jobs': 'Todos los trabajos',
  'Step 3 of 3': 'Paso 3 de 3',
  'View the main photo': 'Ver la foto principal',
  'Main photo of {title}': 'Foto principal de {title}',
  'Field job · Awaiting CRM link':
    'Trabajo de campo · Esperando conexión con el CRM',
  'No signal. Keep taking photos: they’re saved on this phone and upload when signal is back.':
    'Sin señal. Sigue tomando fotos: se guardan en este teléfono y se suben cuando vuelva la señal.',
  'Department folders': 'Carpetas por departamento',
  'On this phone': 'En este teléfono',
  'Photo waiting to upload': 'Foto esperando para subir',
  'Couldn’t upload': 'No se pudo subir',
  Retry: 'Reintentar',
  Delete: 'Borrar',
  'Waiting to upload': 'Esperando para subir',
  '{department} photos': 'Fotos de {department}',
  'Uploaded photos': 'Fotos subidas',
  'All uploaded': 'Todo subido',
  'No photos yet': 'Todavía no hay fotos',
  'Uploaded job photos will appear here.':
    'Aquí van a salir las fotos subidas del trabajo.',
  'View {name}': 'Ver {name}',
  'View job photo': 'Ver foto del trabajo',
  'Job photo': 'Foto del trabajo',
  'Make main photo': 'Poner como foto principal',

  // Photo queue (composables/useFieldQueue.ts)
  'Sign in again to save photos.':
    'Vuelve a iniciar sesión para guardar fotos.',
} as Record<string, string>
